import {useCallback} from "react"

import {USER_SETTINGS_TABS_ID} from "../@constants"
import {isLoadingUserSettingOfficesGroupData, isLoadingUserSettingsAcrissCategoryData, isLoadingUserSettingsSitesProvidersData, isLoadingUserSettingTierData, isLoadingUserSettingSitesGroupData, isLoadingUserSettingWebSupplierGroupData} from "../@signals"
import {useUserSettingsAcriss, useUserSettingsCategory, useUserSettingsOfficesGroup, useUserSettingsProvider, useUserSettingsSite, useUserSettingsTier, useUserSettingsSitesGroup, useUserSettingsWebSupplierGroup} from "./index"


export default function useUserSettingsContent() {
	const { getAcrissData } = useUserSettingsAcriss()
	const { getCategoryData } = useUserSettingsCategory()
	const { getOfficesGroupData } = useUserSettingsOfficesGroup()
	const { getProviderData } = useUserSettingsProvider()
	const { getSitesData } = useUserSettingsSite()
	const { getTiersData } = useUserSettingsTier()
    const { getSitesGroupData } = useUserSettingsSitesGroup()
	const { getWebSupplierGroupData } = useUserSettingsWebSupplierGroup()

	const getAllData = useCallback(() => {
		getAcrissData()
		getCategoryData()
		getOfficesGroupData()
        getSitesGroupData()
		getProviderData()
		getSitesData()
		getTiersData()
		getWebSupplierGroupData()
	}, [])

	return {
		tabs: [{
			label: 'TIERS', value: USER_SETTINGS_TABS_ID.TIER,
			isLoading: isLoadingUserSettingTierData.value,
			iconPosition: 'end',
			disabled: isLoadingUserSettingTierData.value
		}, {
			label: 'OFFICE GROUP', value: USER_SETTINGS_TABS_ID.OFFICE_GROUP,
			isLoading: isLoadingUserSettingOfficesGroupData.value,
			iconPosition: 'end', disabled: isLoadingUserSettingOfficesGroupData.value
		}, {
            label: "SITE GROUP", value:  USER_SETTINGS_TABS_ID.SITE_GROUP,
            isLoading: isLoadingUserSettingSitesGroupData.value,
            iconPosition: 'end', disabled: isLoadingUserSettingSitesGroupData.value
        }, {
			label: 'WEB SUPPLIER GROUPS', value: USER_SETTINGS_TABS_ID.WEB_SUPPLIER_GROUP,
			isLoading: isLoadingUserSettingWebSupplierGroupData.value,
			iconPosition: 'end', disabled: isLoadingUserSettingWebSupplierGroupData.value,
		}, {
			label: 'WEBSITE COLORS', value: USER_SETTINGS_TABS_ID.COLORS_WEBSITE,
			isLoading: isLoadingUserSettingsSitesProvidersData.value,
			iconPosition: 'end', disabled: isLoadingUserSettingsSitesProvidersData.value
		}, {
			label: 'ITEM COLORS', value: USER_SETTINGS_TABS_ID.COLORS_ITEM,
			isLoading: isLoadingUserSettingsAcrissCategoryData.value,
			iconPosition: 'end', disabled: isLoadingUserSettingsAcrissCategoryData.value
		}],

		getAllData
	}
}